import { createStore } from 'vuex'
import auth from './modules/auth'
import settings from './modules/settings'

export default createStore({
  modules: {
    auth,
    settings
  }
})
